// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e8b3e2f","952":"e54dd15c"}[chunkId] + ".chunk.js";
};